<template>
  <div class="header" :class="{ greyHeader: colorNav }">
    <header class="header-inner paddings" :class="{ greyHeader: colorNav }">
      <div class="header-logo" :class="{ hide: mobile }">
        <router-link to="/dashboard">
          <button :class="{ greyHeader: colorNav }" @click="resetAnalyse">
            <!--<img class="logo" src="../assets/Icons/logo-white.svg"/>-->
            <img class="logo" src="../assets/Images/logo-white.png" />
          </button>
        </router-link>
      </div>
      <div class="wrapper-nav">
        <a v-if="!isLoggedIn">
          <button
            class="btn-header"
            @click="
              openLogin();
              setPageRoute('login');
            "
          >
            <div>{{ $t("result.log_in") }}</div>
            <img class="img-login" src="../assets/Icons/log-in.svg" />
          </button>
        </a>
        <div v-else class="dropdown-profile">
          <button class="dropbtn" :class="{ greyHeader: colorNav }">
            <div class="name" v-if="this.firstName !== ''">
              {{
                this.firstName.charAt(0).toUpperCase() + this.firstName.slice(1)
              }}
            </div>
            <div class="profile-img">
              <img src="../assets/Icons/blank-profile.png" alt="" />
            </div>
          </button>
          <div class="dropdown-content">
            <router-link to="/dashboard">
              <button>{{ $t("result.dashboard") }}</button>
            </router-link>
            <router-link to="/profiel">
              <button>{{ $t("result.instellingen") }}</button>
            </router-link>
            <button
              @click="
                logout();
                $router.push({ path: '/' });
              "
            >
              <div>{{ $t("result.log_uit") }}</div>
              <img src="../assets/Icons/log-out.svg" />
            </button>
          </div>
        </div>

        <img
          class="hamburg"
          :class="{ hide: mobile }"
          @click="open"
          src="../assets/Icons/hamburger-white.svg"
        />
        <img
          class="cross"
          :class="{ mobile: mobile }"
          @click="close"
          src="../assets/Icons/close-white.svg"
        />

        <div class="header-nav" :class="{ mobile: mobile }">
          <router-link v-if="isLoggedIn" to="/selectie">
            <button
              @click="resetAnalyse"
              class="btn-header-login"
              :class="{ greyHeader: colorNav }"
            >
              <img class="img-header" src="../assets/Icons/add.svg" />
              <div>{{ $t("result.nieuwe_analyses") }}</div>
            </button>
          </router-link>
          <router-link v-if="isLoggedIn" to="/my-analyses">
            <button class="btn-header-login" :class="{ greyHeader: colorNav }">
              <img class="img-header" src="../assets/Icons/list.svg" />
              <div>{{ $t("result.mijn_analyses") }}</div>
            </button>
          </router-link>
          <router-link to="/faq">
            <button class="faq" :class="{ greyHeader: colorNav }">
              {{ $t("result.faq") }}
            </button>
          </router-link>
          <router-link to="/case-studies">
            <button class="case-studies" :class="{ greyHeader: colorNav }">
              {{ $t("result.case_studies") }}
            </button>
          </router-link>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "TopHeader",
  data() {
    return {
      colorNav: false,
      mobile: false,
    };
  },
  methods: {
    open() {
      this.mobile = true;
    },
    close() {
      this.mobile = false;
    },
    resetAnalyse() {
      this.resetPredefType();
      this.$forceUpdate();
      this.resetGroups();
    },
    toggleNavigation() {
      this.navigationStateSwitch();
    },
    ...mapMutations("predefAnalyse", ["resetPredefType"]),
    ...mapMutations("auth", ["openLogin", "setPageRoute"]),
    ...mapMutations("baseRef", ["saveForLater", "resetGroups", "resetChanges"]),
    ...mapActions("auth", ["logout"]),
  },
  watch: {
    $route() {
      if (
        this.$route.path.substring(1, this.$route.path.lastIndexOf("/")) ===
          "selectie" ||
        this.$route.path === "/selectie"
      ) {
        this.colorNav = true;
      } else {
        this.colorNav = false;
      }
    },
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
    ...mapState("auth", ["showLogin", "firstName"]),
  },
};
</script>

<style lang="sass" scoped>
.greyHeader
  background-color: $grey !important
.mobile
  display: flex !important
.hide
  display: none !important
.header
  background-color: $red
  height: 50px
  box-shadow: 0 5px 5px -5px rgba(0, 0, 0, 0.5)
.header-inner
  display: flex
  max-width: 1660px
  margin: 0 auto
  height: 50px
  box-sizing: border-box
  font-weight: 500
  background-color: $red
  .header-logo
    display: flex
    justify-content: flex-start
    align-items: center
    height: 45px
    .logo
      height: 100%
      margin-top: 2px
      margin-left: -8px
    a
      height: 100%
    button
      background: $red
      border: none
      height: 100%
      color: $white
      font-size: 15px
      font-weight: 500
      text-decoration: none
      padding: 0
  .wrapper-nav
    display: flex
    justify-content: flex-start
    flex-direction: row-reverse
    width: 100%
    position: relative
    .btn-header
      display: flex
      align-items: center
      margin-left: 20px
    .hamburg
      display: flex
      align-self: center
    .cross
      display: none
      align-self: center
    .header-nav
      display: none
      justify-content: flex-end
      height: 50px
      .img-header
        padding-right: 5px
        align-self: center
      .img-login
        padding-left: 5px
        padding-right: 5px
        width: 20px
        align-self: center
      a
        text-decoration: none
      .btn-header-login
        display: flex
        padding: 0px
        padding-right: 29px
      .faq, .case-studies
        align-items: center
      div
        align-self: center
    .img-header
      padding-right: 5px
      align-self: center
    .img-login
      padding-left: 5px
      padding-right: 5px
      width: 20px
      align-self: center
    a
      text-decoration: none
    .btn-header-login
      display: flex
      padding: 0px
      padding-right: 29px
    .faq, .case-studies
      align-items: center
    div
      align-self: center
    .dropdown-profile
      height: 100%
      position: relative
      .dropbtn
        display: flex
        font-family: "Ubuntu"
        font-size: 15px
        line-height: 20px
        align-items: center
        .name
          align-self: center
          display: none
        .profile-img
          border: 1px solid
          border-radius: 20px
          height: 35px
          width: 35px
          margin-left: 20px
          align-self: center
          img
            height: 100%
            width: 100%
            border-radius: 22.5px
    .dropdown-profile .dropbtn
      border: none
      outline: none
      height: 100%
      color: $white
      background-color: $red
      font-weight: 500
      margin: 0
      padding: 0
    .dropdown-content
      display: none
      position: absolute
      top: 50px
      right: 0px
      background-color: $white
      height: 142px
      width: 160px
      box-shadow: 0 2px 7px 0 rgba(0,0,0,0.3)
      padding-left: 20px
      z-index: 20000
      color: $black
    .dropdown-content a
      float: none
      font-size: 15px
      color: $black
      text-decoration: none
      display: block
      text-align: left
    .dropdown-profile:hover .dropdown-content
      display: block
    .dropdown-content
      a
        padding-bottom: 15px
        height: 26px
        font-size: 15px
        line-height: 25px
        font-weight: 500
        &:first-child
          padding-top: 15px
      button
        display: flex
        padding: 0
        font-size: 15px
        line-height: 25px
        height: 27px
        background: none
        border: none
        width: 100%
        color: black
        div
          padding-right: 5px
          font-size: 15px
          line-height: 25px
          font-family: Ubuntu
          font-weight: 500
        img
          align-self: center
          height: 18px
          width: 22px
    a
      height: 100%
      button
        background: $red
        border: none
        height: 100%
        color: $white
        text-decoration: none
        font-family: Ubuntu
        font-size: 12px
        line-height: 20px
        font-weight: 500

@media only screen and (min-width: 576px)
  .header
    .wrapper-nav
      .header-nav
        .img-login
          width: 25px
        .faq
          display: flex
      a
        margin-right: 30px
        &:last-child
          margin-right: 0px
        button
          font-size: 15px

@media only screen and (min-width: 768px)
  .header
    .wrapper-nav
      .header-nav
        .img-login
          width: 25px
        .btn-header-login
          padding-right: 0
        .case-studies
          display: flex

@media only screen and (min-width: 992px)
  .header
    .header-logo
      display: flex
    .wrapper-nav
      display: flex
      justify-content: flex-start
      flex-direction: row-reverse
      width: 100%
      .btn-header
        margin-left: 40px
      .hamburg
        display: none
      .cross
        display: none
      .header-nav
        display: flex
        .img-login
          padding-right: 0px
      .dropdown-profile
        .dropbtn
          .name
            margin-left: 30px
            display: flex

@media only screen and (min-width: 1200px)
  .header-logout, .header-login
    padding-left: 75px
    padding-right: 75px

@media only screen and (min-width: 1660px)
  .header-logout, .header-login
    padding-left: 75px
    padding-right: 75px
    height: 50px
    .header-logo
      height: 45px
      .logo
        margin-top: 2px
        margin-left: -8px
      button
        font-size: 15px
    .header-nav
      height: 50px
      .img-header
        padding-right: 5px
      .img-login
        padding-left: 5px
      .dropdown-profile
        padding-left: 40px
        .dropbtn
          font-size: 15px
          line-height: 20px
          .profile-img
            margin-left: 20px
            height: 35px
            width: 35px
      .dropdown-content
        top: 50px
        height: 142px
        width: 160px
        padding-left: 20px
      .dropdown-content a
        font-size: 15px
      .dropdown-content
        a
          padding-bottom: 15px
          height: 26px
          font-size: 15px
          line-height: 25px
          &:first-child
            padding-top: 15px
        button
          font-size: 15px
          line-height: 25px
          height: 27px
          div
            padding-right: 5px
            font-size: 15px
            line-height: 25px
          img
            height: 18px
            width: 22px
      a
        button
          font-size: 15px
          line-height: 20px
</style>
